export default __webpack_public_path__ + "static/media/icon-user.28de6a42.svg";